import RadioInput from "../../../shared/radioInput";
import ValuedTextBox from "../../../shared/valuedTextBox";
import {
  alwaysDisabledFields,
  conditionalDisabledFieldsEdit,
} from "../../../utils/fieldConstants";

interface intakeFieldsProps {
  mode: any;
  localProjectData: {
    project_id: any;
    project_name: any;
    project_brief: any;
    project_lead_name: any;
    project_lead_email: any;
    business_stack_req_group: any;
    sector: any;
    consulting_type: any;
    estimated_project_start_date: any;
    estimated_project_end_date: any;
    consulting_company: any;
    final_total_cost: any;
    rate_value_received: any;
    core_deliverables: any;
    RITM_number: any;
    preferred_vendor: any;
    is_address_business_problem: any;
    is_internal_team_address_business_problem: any;
    is_proceed_further: any;
    requested_by: any;
    location: any;
    request_manager: any;
    email: any;
    finance_lead_name: any;
    finance_lead_email: any;
    cost_center: any;
    geo_graphic_scope: any;
    is_new_consulting_project: any;
    project_budget: any;
    is_follow_up:any;
  };
}

const IntakeFields: React.FC<intakeFieldsProps> = ({
  mode,localProjectData,
}) => {
  const isFieldDisabled = (fieldName: string, mode: string): boolean => {
    // Always disable fields listed in alwaysDisabledFields
    if (alwaysDisabledFields.includes(fieldName)) {
      return true;
    }

    // In edit mode, disable fields listed in conditionalDisabledFieldsEdit
    if (mode === "edit" && conditionalDisabledFieldsEdit.includes(fieldName)) {
      return true;
    }

    return false; // Fields are enabled by default if they are not in the above lists
  };
  var defaultCoreDeliverables = localProjectData?.core_deliverables || "";
  var defaultConsultingCompany = localProjectData.preferred_vendor || "";
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        flexDirection: "column",
      }}
    >
      <div className="form-container">
        <ValuedTextBox
          label={"RITM Number"}
          value={localProjectData.RITM_number}
          disabled={isFieldDisabled("RITM_number", mode)}
          multiline={false}
        />

        <ValuedTextBox
          label={"Project ID"}
          value={localProjectData.project_id}
          disabled={isFieldDisabled("project_id", mode)}
          multiline={false}
        />

        <RadioInput
          label={
            "Does the required capability (technical, strategic, operational) to address the business problem exist internally at PEP?"
          }
          value={localProjectData.is_address_business_problem || ""}
          disabled={isFieldDisabled("is_address_business_problem", mode)}
        />

        <RadioInput
          label={
            "Does the internal team have the bandwidth to address the problem given current/expected workload?"
          }
          value={
            localProjectData.is_internal_team_address_business_problem || ""
          }
          disabled={isFieldDisabled(
            "is_internal_team_address_business_problem",
            mode
          )}
        />

        <RadioInput
          label={
            "Does the problem require external benchmarking/scoping,or an 'outside-in' POV to catalyze action?"
          }
          value={
            localProjectData.is_internal_team_address_business_problem || ""
          }
          disabled={isFieldDisabled(
            "is_internal_team_address_business_problem",
            mode
          )}
        />

        <RadioInput
          label={"Based on this guidance, would you like to proceed further?"}
          value={localProjectData.is_proceed_further || ""}
          disabled={isFieldDisabled("is_proceed_further", mode)}
        />

        <ValuedTextBox
          label={"Requested by"}
          value={localProjectData.requested_by}
          disabled={isFieldDisabled("requested_by", mode)}
          multiline={false}
        />

        <ValuedTextBox
          label={"Location"}
          value={localProjectData.location}
          disabled={isFieldDisabled("location", mode)}
          multiline={false}
        />

        <ValuedTextBox
          label={"Requestor Manager"}
          value={localProjectData.request_manager}
          disabled={isFieldDisabled("request_manager", mode)}
          multiline={false}
        />

        <ValuedTextBox
          label={"Email"}
          value={localProjectData.email}
          disabled={isFieldDisabled("email", mode)}
          multiline={false}
        />

        <ValuedTextBox
          label={"Project Lead Name"}
          value={localProjectData.project_lead_name}
          disabled={isFieldDisabled("project_lead_name", mode)}
          multiline={false}
        />

        <ValuedTextBox
          label={"Business Stakeholder Requesting Group"}
          value={localProjectData.business_stack_req_group}
          disabled={isFieldDisabled("business_stack_req_group", mode)}
          multiline={false}
        />

        <ValuedTextBox
          label={"Finance Lead Name"}
          value={localProjectData.finance_lead_name}
          disabled={isFieldDisabled("finance_lead_name", mode)}
          multiline={false}
        />

        <ValuedTextBox
          label={"Finance Lead Email"}
          value={localProjectData.finance_lead_email}
          disabled={isFieldDisabled("finance_lead_email", mode)}
          multiline={false}
        />

        <ValuedTextBox
          label={"Cost Center"}
          value={localProjectData.cost_center}
          disabled={isFieldDisabled("cost_center", mode)}
          multiline={false}
        />
        <ValuedTextBox
          label={"Sector"}
          value={localProjectData.sector}
          disabled={isFieldDisabled("sector", mode)}
          multiline={false}
        />
        <ValuedTextBox
          label={"Geographic Scope (Region)"}
          value={localProjectData.geo_graphic_scope}
          disabled={isFieldDisabled("geo_graphic_scope", mode)}
          multiline={false}
        />
        <RadioInput
          label={"Is this a new consulting project or a contract extension?"}
          value={localProjectData.is_new_consulting_project || ""}
          disabled={isFieldDisabled("is_new_consulting_project", mode)}
        />

        <ValuedTextBox
          label={"Project Name"}
          value={localProjectData.project_name}
          disabled={isFieldDisabled("project_name", mode)}
          multiline={false}
        />

        <ValuedTextBox
          label={"Project Brief"}
          value={localProjectData.project_brief}
          disabled={isFieldDisabled("project_brief", mode)}
          multiline={true}
        />

        <ValuedTextBox
          label={"Consulting Type"}
          value={localProjectData.consulting_type}
          disabled={isFieldDisabled("consulting_type", mode)}
          multiline={false}
        />

        <ValuedTextBox
          label={"Estimated Project Start Date"}
          value={localProjectData.estimated_project_start_date}
          disabled={isFieldDisabled("estimated_project_start_date", mode)}
          multiline={false}
        />

        <ValuedTextBox
          label={"Estimated Project End Date"}
          value={localProjectData.estimated_project_end_date}
          disabled={isFieldDisabled("estimated_project_end_date", mode)}
          multiline={false}
        />

        <RadioInput
          label={
            "Are you planning to use PwC, Deloitte, or EY for this consulting work?"
          }
          value={localProjectData.is_new_consulting_project || ""}
          disabled={isFieldDisabled("is_new_consulting_project", mode)}
        />

        <ValuedTextBox
          label={"Preferred Vendor(s)"}
          value={defaultConsultingCompany}
          disabled={isFieldDisabled("preferred_vendor", mode)}
          multiline={true}
          rows={2}
        />

        <ValuedTextBox
          label={"State the core deliverables of the project"}
          value={defaultCoreDeliverables}
          disabled={isFieldDisabled("core_deliverables", mode)}
          multiline={true}
          rows={2}
        />

        <ValuedTextBox
          label={
            "Please provide estimated consulting services cost or your budget for this project"
          }
          value={localProjectData.project_budget}
          disabled={isFieldDisabled("project_budget", mode)}
        />

        <RadioInput
          label={
            "Do you envision any follow-up work or additional phases (V1 - During Intake Form filling up)?"
          }
          value={localProjectData.is_follow_up || ""}
          disabled={isFieldDisabled("is_follow_up", mode)}
        />
      </div>
    </div>
  );
};

export default IntakeFields;
